<template>
	<div>		
		<v-content>
			<v-container fluid>			
              <v-flex xs3>
                <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
              </v-flex>
				<v-data-table :headers="headers" :search="search" :items="tenderList" hide-actions class="elevation-1" style="font-size: 10px;">
					<template slot="items" slot-scope="props">						
						<td class="text-xs-right">{{ props.item.project_name }}</td>      
						<td class="text-xs-right">{{ props.item.quote_data.length }}</td>      
						<td class="text-xs-right">{{ props.item.created_date }}</td>
						<td class="text-xs-right">{{ props.item.project_status }}</td>						
						<td class="text-xs-right">{{ props.item.tender_status }}</td>						
						<td class="text-xs-right">{{ fncFilter(props.item.tender_closing_date) }}</td>						
						<td class="text-xs-right">{{ fncFilter(props.item.project_code) }}</td>						
						<td class="text-xs-right">{{ fncFilter(props.item.reference) }}</td>						
						<td class="text-xs-right">{{ props.item.project_type }}</td>						
						<td class="text-xs-right"><strong>{{ fncFilterPrice(props.item.tender_total) }}</strong></td>						
					</template>
				</v-data-table>			
			</v-container>
		</v-content>	
	</div>
</template>

<script>
	
  import { mapGetters } from 'vuex'; 

  export default {
	name: 'TenderList',
	intRoleEdit: 0,
    data () {
		return {	
			search: '',
			headers: [         
				{ text: 'Project Name', value: 'project_name' },
				{ text: 'No of Quotes', value: 'quote_data' },
				{ text: 'Created Date', value: 'created_date' },
				{ text: 'Project Status', value: 'project_status' },
				{ text: 'Project Tender Status', value: 'tender_status' },
				{ text: 'Tender Closing Date', value: 'tender_closing_date' },
				{ text: 'Project Code', value: 'project_code' },
				{ text: 'Project Reference', value: 'reference' },
				{ text: 'Project Type', value: 'project_type' },
				{ text: 'Tender Total', value: 'tender_total' }			
			]	
		}		
	},
	methods: {
		fncFilter( filterVar ) {
			if( filterVar === '' || filterVar === undefined || filterVar == null || filterVar == 'null' ) {
				return 'N/A';
			} else {
				return filterVar
			}		
		},
		fncFilterPrice( filterVar ) {
			var currencyValue = parseFloat(filterVar).toFixed(2);
			currencyValue = currencyValue.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
			return 'R' + currencyValue;
		}
	},
	computed: {
		...mapGetters([			
			'objAuthorize',
			'tenderList'
		])
	},
	beforeMount() {
		this.$store.dispatch('fncPopulateTenderList');		
	}
}	
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>